import React, { useEffect, useMemo, useState } from 'react';
import { MaterialReactTable } from 'material-react-table';
import 'bootstrap/dist/css/bootstrap.css';
import { BsPencilFill, BsFillEnvelopeFill } from 'react-icons/bs';
import SendEmailModal from '../../components/common/sendEmailModal';

const SendEmailPage = () => {
  document.title = 'Send Email | SNB Offsite';

  const [isModalOpen, setModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });

  const openModal = (name, email) => {
    setFormData({
      'name': name, 
      'email': email
    });
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
      if (formData?.email && formData?.name){
        setModalOpen(true)
      }
  }, [formData])

  const [dataRequired, setDataRequired] = useState([
    {
      details: {
        serial: '1',
        user: 'Tahira',
        id: '101',
        title: 'Mrs',
        modify: <BsFillEnvelopeFill onClick={() => openModal('Tahira', 'tahira@gmail.com')} style={{ cursor: 'pointer', fontSize: '1.5rem' }} />,
      },
    },
    {
      details: {
        serial: '2',
        user: 'Malik',
        id: '102',
        title: 'Mr',
        modify: <BsFillEnvelopeFill onClick={() => openModal('Malik', 'malik@gmail.com')} style={{ cursor: 'pointer', fontSize: '1.5rem' }} />,
      },
    },
  ]);

  const columnsRequired = useMemo(
    () => [
      {
        accessorKey: 'details.serial',
        header: '#',
        size: 50,
      },

      {
        accessorKey: 'details.title',
        header: 'Title',
        size: 120,
      },

      {
        accessorKey: 'details.user',
        header: 'Guest Name',
        size: 120,
      },
      {
        accessorKey: 'details.id',
        header: 'Guest ID',
        size: 120,
      },

      {
        accessorKey: 'details.modify',
        header: 'Send Email',
        size: 120,
      },
    ],
    []
  );

  const updateDataRequired = (editedTitle , editedUserName, editedUserID) => {
    const index = dataRequired.findIndex((item) => item.details.user === formData.name);

    const updatedData = [...dataRequired];
    updatedData[index] = {
      details: {
        serial: dataRequired[index].details.serial,
        title: editedTitle,
        user: editedUserName,
        id: editedUserID,
        
        modify: dataRequired[index].details.modify,
      },
    };
    setDataRequired(updatedData);
  };

  return (
    <>
      <div>
        <div
          className="container-fluid breadcrumb-color d-flex align-items-center mb-3"  id='breadCrumbStyling'>
          <nav aria-label="breadcrumb" className="d-flex align-items-center">
            <ol className="breadcrumb">
              <li
                className="breadcrumb-item text-white text-center active fs-4 pt-3 ps-2"
                aria-current="page"
                id='breadCrumbTitleStyling'
              >
                Send Email
              </li>
            </ol>
          </nav>
        </div>

        <div className="container-fluid p-4" id='formStyling'>
              <MaterialReactTable
                columns={columnsRequired}
                data={dataRequired}
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                  },
                }}
              />

              <SendEmailModal
                isOpen={isModalOpen}
                toggle={closeModal}
                name={formData.name}
                email={formData.email}
                updateDataRequired={updateDataRequired}
              />
        </div>
      </div>
    </>
  );
};

export default SendEmailPage;
